__turbopack_context__.v({
  "background": "practice-page-module-scss-module__kDp33G__background",
  "border": "practice-page-module-scss-module__kDp33G__border",
  "form": "practice-page-module-scss-module__kDp33G__form",
  "root": "practice-page-module-scss-module__kDp33G__root",
  "style": "practice-page-module-scss-module__kDp33G__style",
  "typoGraphyRight": "practice-page-module-scss-module__kDp33G__typoGraphyRight",
  "typoGraphyWrong": "practice-page-module-scss-module__kDp33G__typoGraphyWrong",
});
